import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Application, ApplicationGroupTile, ApplicationTile } from '../models/index';
import { DataPage } from './../../common/models/DataPage';
import { GaSessionConfigService } from './../../session/services/session.config.service';
import { ITileWithIcon } from './../models/ITileWithIcon';
import { GaApplicationsConfigService } from './applications.config.service';

@Injectable()
export class MnApplicationsDataService {

    private RESOURCE = '/api/v1/admin/apps';
    private RESOURSE_GROUPS = '/api/v1/admin/apps_groups';

    public constructor(
        private applicationsConfig: GaApplicationsConfigService,
        private sessionConfig: GaSessionConfigService,
        private http: HttpClient,
    ) { }

    private _updateIcons<T extends ITileWithIcon>(items: T[]): T[] {
        for (const item of items) {
            if (item.icon && typeof item.icon === 'string') {
                item.iconView = JSON.parse(item.icon);
            }
        }
        return items;
    }

    public readApplicationsGroups(): Observable<ApplicationGroupTile[]> {
        const url = this.sessionConfig.serverUrl + this.RESOURSE_GROUPS;

        return this.http.get(url)
            .pipe(
                map((data: DataPage<ApplicationGroupTile>) => data.data),
                map((groups: ApplicationGroupTile[]) => this._updateIcons<ApplicationGroupTile>(groups))
            );
    }

    public readApplications(params?: { skip?: number, take?: number, filter?: string }): Observable<ApplicationTile[]> {
        const url = this.sessionConfig.serverUrl + this.RESOURCE;
        let pars = new HttpParams({ fromObject: { product: this.applicationsConfig.config.productName } });
        if (params) {
            for (const key of Object.keys(params)) {
                pars = pars.set(key, params[key].toString());
            }
        }

        return this.http.get<DataPage<ApplicationTile>>(url, { params: pars })
            .pipe(
                map(response => response.data),
                map((apps: ApplicationTile[]) => this._updateIcons<ApplicationTile>(apps))
            );
    }

    public updateApplication(id: string, app: Application): Observable<any> {
        const url = this.sessionConfig.serverUrl + this.RESOURCE + '/' + id;
        let params = new HttpParams();
        params = params.set('product', this.applicationsConfig.config.productName);

        return this.http.put(url, app, { params });
    }

    public createApplication(app: Application): Observable<any> {
        const url = this.sessionConfig.serverUrl + this.RESOURCE;
        let params = new HttpParams();
        params = params.set('product', this.applicationsConfig.config.productName);

        return this.http.post(url, app, { params });
    }

    public deleteApplication(id: Application | string): Observable<any> {
        const aid = typeof id === 'string' ? id : id.id;
        const url = this.sessionConfig.serverUrl + this.RESOURCE + '/' + aid;
        let params = new HttpParams();
        params = params.set('product', this.applicationsConfig.config.productName);

        return this.http.delete(url, { params })
            .pipe(map(() => aid));
    }

}
